const AccountNav = () => {

  const nav = document.querySelector('.AccountNavigation')
  const ordersLink = document.querySelector('.AccountNavigationOrders')
  const subLink = document.querySelector('.AccountNavigationSubscriptions')
  console.log(window.location.pathname)

  if (window.location.pathname.indexOf('login')) {
    nav.style.display = 'none'
  }
  if (window.location.pathname.indexOf('register')) {
    nav.style.display = 'none'
  }
  if (window.location.pathname === '/account/' || window.location.pathname === '/account') {
    nav.style.display = 'flex'
    ordersLink.classList.add('AccountNavigationLinkActive')
    subLink.classList.remove('AccountNavigationLinkActive')
  }
  // if (window.location.pathname.indexOf('tools')) {
  //   nav.style.display = 'flex'
  //   ordersLink.classList.remove('AccountNavigationLinkActive')
  //   subLink.classList.add('AccountNavigationLinkActive')
  // }
  
  console.log('xxx')

}

export default AccountNav